import React, { useState } from 'react';
import { Brain, Mail, AlertCircle, CheckCircle } from 'lucide-react';
import api from '../services/api';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | loading | sent | error
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');
    try {
      await api.post('/auth/forgot-password', { email });
      setStatus('sent');
    } catch (err) {
      setErrorMsg(err.response?.data?.message || 'Something went wrong');
      setStatus('error');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900">
      <div className="w-full max-w-md px-6 pt-10 pb-8 bg-gray-800 shadow-xl rounded-2xl space-y-8">
        <div className="text-center">
          <div className="flex justify-center mb-4">
            <div className="p-3 bg-gradient-to-br from-blue-500 to-purple-600 rounded-2xl">
              <Brain size={40} className="text-white" />
            </div>
          </div>
          <h2 className="text-3xl font-bold bg-gradient-to-r from-blue-400 to-purple-500 text-transparent bg-clip-text">
            Reset Password
          </h2>
          <p className="mt-2 text-gray-400">We'll send a reset link to your email</p>
        </div>

        {status === 'sent' ? (
          <div className="p-4 bg-green-500 bg-opacity-10 border border-green-500 border-opacity-30 rounded-xl">
            <div className="flex items-center space-x-2 text-green-400">
              <CheckCircle size={20} />
              <span className="text-sm">Check your inbox — link expires in 10 minutes. If you don't see it, check your spam or junk folder.</span>
            </div>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-6">
            {status === 'error' && (
              <div className="p-4 bg-red-500 bg-opacity-10 border border-red-500 border-opacity-30 rounded-xl">
                <div className="flex items-center space-x-2 text-red-500">
                  <AlertCircle size={20} />
                  <span className="text-sm">{errorMsg}</span>
                </div>
              </div>
            )}

            <div className="relative">
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <Mail size={20} className="text-gray-500" />
              </div>
              <input
                type="email"
                required
                className="w-full pl-12 pr-4 py-3 bg-gray-700 border border-gray-600 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent placeholder-gray-400 text-white transition-all"
                placeholder="Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <button
              type="submit"
              disabled={status === 'loading'}
              className="w-full py-3 px-4 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-xl hover:opacity-90 disabled:opacity-50 transition-all font-medium"
            >
              {status === 'loading' ? 'Sending...' : 'Send Reset Link'}
            </button>

            <p className="text-center text-gray-400 text-sm">
              <a href="/login" className="text-blue-400 hover:text-blue-300 transition-colors">
                Back to login
              </a>
            </p>
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
